import { useCallback } from 'react';
import useAvailableOffersStepsBase from '@fingo/lib/features/factoring/hooks/useAvailableOffersStepsBase';
import AvailableOffersDateSelectionStep from '@fingo/lib/features/factoring/components/availableOffersSteps/AvailableOffersDateSelectionStep';
import AvailableOffersCessionStep from '@fingo/lib/features/factoring/components/availableOffersSteps/AvailableOffersCessionStep';
import AvailableOffersSummary from '@fingo/lib/features/factoring/components/summaries/AvailableOffersSummary';
import OPTIONS from '../constants/available-offers-options';
import FACTORING_TUTORIALS from '../constants/header-tutorials';
import {
  getClientColumns,
  getColumns,
  DETAILS_HEADERS,
  DETAILS_MOBILE_HEADERS,
} from '../constants/available-offers';
import { getAvailableOffersInformationStackMessage } from '../constants/available-offers-information-stack-messages';

const useAvailableOffersSteps = (
  setShowConfirmationSummary,
  setShowCessionStep,
  stepsConditions,
  isBlocked,
  unavailabilityCode,
  onRegisterCessionNavigation,
) => {
  const getShoppingCartProps = useCallback((handleCloseCessionStep) => ({
    toggleMenu: handleCloseCessionStep,
    useSummaryStep: false,
    onRegisterNavigation: onRegisterCessionNavigation,
    showStepper: false,
  }), [onRegisterCessionNavigation]);

  const getInformationStackText = useCallback(
    ({ isBlocked: blocked, unavailabilityCode: code }) => (
      getAvailableOffersInformationStackMessage(blocked, code)
    ),
    [],
  );

  return useAvailableOffersStepsBase({
    DateSelectionStepComponent: AvailableOffersDateSelectionStep,
    CessionStepComponent: AvailableOffersCessionStep,
    countryConfig: OPTIONS,
    tutorial: FACTORING_TUTORIALS.available_offers,
    stepsConditions,
    setShowConfirmationSummary,
    setShowCessionStep,
    SummaryComponent: AvailableOffersSummary,
    isBlocked,
    unavailabilityCode,
    getShoppingCartProps,
    getClientColumns,
    getDetailsColumns: getColumns,
    detailsHeaders: DETAILS_HEADERS,
    detailsMobileHeaders: DETAILS_MOBILE_HEADERS,
    getInformationStackText,
  });
};

export default useAvailableOffersSteps;
